import React, { Fragment } from "react"
import { Link } from "gatsby"

const NgGlobalOptions = (props) => {
    return (
        <Fragment>
            <div className="kuda-footer--col">
                <p className="footer-header text-bold color-primary">Personal</p>
                <ul className="kuda-footer--menu color-black">

                    <li>
                        <Link to="/en-ng/">Discover Personal</Link>
                    </li>
                    <li>
                        <Link to="/en-ng/spend/">Transfer & Spend</Link>
                    </li>
                    <li>
                        <Link to="/en-ng/save/">Save</Link>
                    </li>

                    <li>
                        <Link to="/en-ng/investments/">Investments</Link>
                    </li>
                    <li>
                        <Link to="/en-ng/cards/">Kuda card</Link>
                    </li>
                    <li>
                        <Link to="/en-ng/personal-loan/">Loans</Link>
                    </li>
                    <li>
                        <Link to="/en-ng/overdrafts/">Overdrafts</Link>
                    </li>
                </ul>
            </div>
            <div className="kuda-footer--col">
                <p className="footer-header text-bold color-primary">Business</p>
                <ul className="kuda-footer--menu color-black">

                    <li>
                        <Link to="/en-ng/business/">Discover Business</Link>
                    </li>
                    <li>
                        <Link to="/en-ng/business/registration-cac-tin/">Business Registration</Link>
                    </li>
                    <li>
                        <Link to="/en-ng/business/softpos-payments/">softPOS</Link>
                    </li>

                    <li>
                        <Link to="/en-ng/business/invoicing/">Invoicing</Link>
                    </li>

                    <li>
                        <Link to="/en-ng/business/pos/">POS Machine</Link>
                    </li>
                    <li>
                        <Link to="/en-ng/business/loans/">Business Loan</Link>
                    </li>

                    <li>
                        <Link to="/en-ng/business/open-api/">Business API</Link>
                    </li>

                    <li>
                        <Link to="/joinkudabusiness/">Join Kuda Business</Link>
                    </li>
                </ul>
            </div>
            <div className="kuda-footer--col">
                <p className="footer-header text-bold color-primary">Company</p>
                <ul className="kuda-footer--menu color-black">

                    <li>
                        {/* <a
                            href="https://joinkuda.medium.com/"
                            target="_blank"
                            rel="nofollow noopener noreferrer"
                        >
                            Blog
                        </a> */}
                        <Link
                            to="/blog/"
                            className="menu-link"
                        > Blog

                        </Link>
                    </li>
                    <li>
                        <Link to="/press/">Press</Link>
                    </li>
                    <li>
                        <Link to="/careers/">Join Our Team</Link>
                    </li>
                    <li>
                        <Link to="/about/">About Us</Link>
                    </li>
                    {props?.selectCountry ==="Nigeria" && <li>
                        <Link to="/en-ng/kudamfb/">Kuda in Nigeria</Link>
                    </li>
}
                </ul>
            </div>
            <div className="kuda-footer--col">
                <p className="footer-header text-bold color-primary">Help</p>
                <ul className="kuda-footer--menu color-black">

                    <li>
                        <a
                            href="https://help.kuda.com/en/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Get Help
                        </a>

                    </li>
                    <li>
                        <Link to="/scam-awareness/" rel="nofollow">Scam Awareness</Link>
                    </li>
                    <li>
                        <Link to="/en-ng/legal/faq/">FAQs</Link>
                    </li>
                    <li>
                        <Link to="/security/">Security</Link>
                    </li>
                    <li>
                        <Link to="/contact/">Contact Us</Link>
                    </li>
                    <li>
                        <a
                            href="https://selfhelp.kuda.com/"
                            target="_blank"
                            rel="noopener noreferrer nofollow"
                        >
                            Self Help
                        </a>

                    </li>

                </ul>
            </div>
            <div className="kuda-footer--col">
                <p className="footer-header text-bold color-primary">Transparency</p>
                <ul className="kuda-footer--menu color-black">


                    <li>
                        <Link to="/en-ng/legal/terms/" rel="nofollow">Terms & Conditions</Link>
                    </li>
                    <li>
                        <Link to="/mobile/ng/legal/privacy-policy/" rel="nofollow">Privacy Policy</Link>
                    </li>
                    <li>
                        <Link to="/en-ng/legal/information-security-policy/" rel="nofollow">Information Security Policy</Link>
                    </li>
                    <li>
                        <Link to="/en-ng/legal/cookie-policy/" rel="nofollow">Cookie Policy</Link>
                    </li>
                    <li>  <a
                        href="https://help.kuda.com/support/solutions/articles/73000621873-whistleblowing"
                        target="_blank"
                        rel="noopener noreferrer nofollow"
                    >
                        Whistleblowing Policy
                    </a>

                    </li>

                </ul>
            </div>
        </Fragment>)
}
export default NgGlobalOptions